export function slugify(value: string) {
  return value
    .toLowerCase()
    .trim()
    .replace(/&/g, " and ")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

export function postPath(slug: string) {
  return `/wiki/${slug}`;
}

export function categoryPath(category: string) {
  return `/category/${slugify(category)}`;
}

export function tagPath(tag: string) {
  return `/tag/${slugify(tag)}`;
}

export function authorPath(slug: string) {
  return `/author/${slug}`;
}
